export function isHTMLElement(node: Node): node is HTMLElement {
  return node instanceof HTMLElement
}
